import { UpIcon } from "@src/components/elements";
import { CheckIcon } from "@src/components/elements/assets/CheckIcon";
import { Step } from "@src/components/modules/SegmentedStepBar/useSegmentedStepBar";
import React from "react";
import styled from "styled-components/macro";

const StyledRoot = styled.div`
  display: flex;
  gap: 0.5rem;
  padding: 0.5rem;
  background: var(--background-gray);
  width: 100%;
  overflow: auto;
  min-height: 3rem;

  .step-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    font-size: var(--font-size-small);
    font-weight: var(--font-weight-bold);
    min-width: fit-content;
    &:last-of-type {
      .spacer {
        display: none;
      }
    }
  }

  .step {
    flex-grow: 0;
    border-radius: var(--rounded-corner);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 0.25rem 0.5rem;

    &.active {
      background: var(--background-green);
      color: var(--dark-green);
      .step-number {
        background: var(--dark-green);
        color: white;
      }
    }

    .step-number {
      border-radius: 1rem;
      background: var(--page-background);
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 1.5rem;
      min-height: 1.5rem;

      &.completed {
        background: var(--green);
        fill: white;
        stroke: white;
      }

      svg {
        width: 0.75rem;
      }
    }
  }

  .spacer {
    transform: rotate(90deg);
    fill: var(--border-gray);
  }
`;

interface Props {
  steps: Step[];
  className?: string;
}

export const SegmentedStepBar: React.FC<Props> = ({ steps, className }) => {
  return (
    <StyledRoot className={className}>
      {steps.map((step, index) => (
        <div key={index} className="step-wrap">
          <div className={`step ${step.active ? "active" : ""}`}>
            {step.completed ? (
              <>
                <div className="step-number completed">
                  <CheckIcon opacity="0.38" />
                </div>
                <div>{step.title}</div>
              </>
            ) : (
              <>
                <div className="step-number">{index + 1}</div>
                <div>{step.title}</div>
              </>
            )}
          </div>

          <UpIcon className="spacer" />
        </div>
      ))}
    </StyledRoot>
  );
};
